"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const mobx_react_1 = require("mobx-react");
const react_dropzone_1 = __importDefault(require("react-dropzone"));
const mobx_1 = require("mobx");
const styles_1 = __importDefault(require("../../styles"));
const openDropZone = field => (e) => {
    e.preventDefault();
    field.state.extra('dropzone').open();
    console.log(field.name, '>> extra(\'dropzone\') >> open()');
};
const getFiles = field => (e) => {
    e.preventDefault();
    console.log(field.name, '>> getFiles', field.files);
};
const destroyPreview = (file, field) => (e) => {
    e.preventDefault();
    // eslint-disable-next-line
    window.URL.revokeObjectURL(file.preview);
    // eslint-disable-next-line
    console.log('file.preview', file.preview);
    // remove file from array
    const index = field.files[0].indexOf(file);
    (0, mobx_1.action)(() => field.files[0].splice(index, 1))();
};
exports.default = (0, mobx_react_1.observer)(({ field }) => (react_1.default.createElement("div", null,
    react_1.default.createElement(react_dropzone_1.default, { onDrop: field.onDrop, ref: dropzone => field.state.extra({ dropzone }) },
        react_1.default.createElement("div", null, "Try dropping some files here, or click to select files to upload.")),
    react_1.default.createElement("button", { type: "button", onClick: openDropZone(field), className: styles_1.default.ctrl }, "Open Dropzone"),
    react_1.default.createElement("button", { onClick: getFiles(field), className: styles_1.default.ctrl }, "Get Files"),
    (field.files && field.files[0].length) ? react_1.default.createElement("div", null,
        react_1.default.createElement("h2", null,
            "Uploading ",
            field.files[0].length,
            " files..."),
        react_1.default.createElement("div", null, field.files[0].map(file => react_1.default.createElement("button", { key: file.name, onClick: destroyPreview(file, field), className: styles_1.default.ctrl },
            react_1.default.createElement("img", { className: "w-10 h-10", src: file.preview, alt: file.name }))))) : null)));
